import { render, staticRenderFns } from "./PresentTabContent.vue?vue&type=template&id=176796e6&scoped=true"
import script from "./PresentTabContent.vue?vue&type=script&lang=js"
export * from "./PresentTabContent.vue?vue&type=script&lang=js"
import style0 from "./PresentTabContent.vue?vue&type=style&index=0&id=176796e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176796e6",
  null
  
)

export default component.exports